var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('snackbar',{ref:"snackbar",attrs:{"holdTime":5000,"position":"top-right"}})}
var staticRenderFns = []

export { render, staticRenderFns }